import PageHero from "@/components/PageHero";

function Section({ title, children }) {
  return (
    <div className="mb-8">
      <h2 className="font-display text-2xl md:text-3xl tracking-wider text-jpa-primary mb-3">{title}</h2>
      <div className="text-jpa-muted leading-relaxed space-y-3 text-sm md:text-base">{children}</div>
    </div>
  );
}

export default function PolicyLayout({ testId, eyebrow, title, subtitle, effective, children }) {
  return (
    <div data-testid={testId}>
      <PageHero
        eyebrow={eyebrow}
        title={title}
        subtitle={subtitle}
        image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1800"
      />
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
        {effective && (
          <div className="text-xs uppercase tracking-widest text-jpa-muted mb-8">Effective: {effective}</div>
        )}
        {children}
        <div className="mt-12 border-t border-jpa-border pt-6 text-xs text-jpa-muted">
          For any queries about this policy, write to <a href="mailto:info@jpaofficial.com" className="text-jpa-primary font-bold">info@jpaofficial.com</a> or call
          <span className="font-bold text-jpa-ink"> +91 93047 57995</span>.
        </div>
      </div>
    </div>
  );
}

export { Section };
